import { environment } from 'src/environments/environment';
import { LIBRARY_STATE } from 'src/app/state';

/**
 * Feature Flag
 */
export function isLibrarySliceFeatureEnabled(): boolean {
  return !environment.production;
}

/**
 * Persistence
 */

export type LibrarySlicePersistenceMode = 'local' | 'api';

const RUNTIME_OVERRIDE_KEY = 'stamo.librarySlicePersistence';

/** Resolve persistence mode. Override at runtime via localStorage key `stamo.librarySlicePersistence`. */
export function getLibrarySlicePersistenceMode(): LibrarySlicePersistenceMode {
  try {
    const override = localStorage.getItem(RUNTIME_OVERRIDE_KEY);
    if (override === 'api' || override === 'local') {
      return override;
    }
  } catch {
    /* SSR / private browsing */
  }

  return environment.librarySlicePersistence ?? 'local';
}

export function isLibrarySliceApiPersistence(): boolean {
  return getLibrarySlicePersistenceMode() === 'api';
}

/** NgXS storage-plugin keys for library state (empty when API mode). */
export function librarySliceStorageKeys(): string[] {
  return isLibrarySliceApiPersistence() ? [] : [LIBRARY_STATE];
}
